module.exports = __webpack_public_path__ + "img/Frame_L.00fc55e4.png";